import React from 'react';

/**
 * Fondo animado: manchas de color que se desplazan muy lento detrás del
 * contenido. Los colores salen de la paleta de marca (verde azulado + durazno)
 * y las opacidades se mantienen bajas para no competir con el texto.
 */
const GradientMeshBackground = () => {
  const blobs = [
    {
      // verde azulado, arriba a la izquierda
      width: '46%',
      height: '46%',
      top: '4%',
      left: '6%',
      background: 'radial-gradient(circle, rgba(14, 124, 123, 0.16) 0%, transparent 70%)',
      borderRadius: '40% 60% 70% 30% / 40% 50% 60% 50%',
      animation: 'hanaBlobA 26s infinite ease-in-out',
    },
    {
      // durazno, abajo a la derecha
      width: '40%',
      height: '40%',
      bottom: '6%',
      right: '6%',
      background: 'radial-gradient(circle, rgba(242, 166, 90, 0.15) 0%, transparent 70%)',
      borderRadius: '60% 40% 30% 70% / 60% 30% 70% 40%',
      animation: 'hanaBlobB 32s infinite ease-in-out',
    },
    {
      // verde azulado claro, al centro
      width: '34%',
      height: '34%',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background: 'radial-gradient(circle, rgba(93, 179, 176, 0.13) 0%, transparent 70%)',
      borderRadius: '70% 30% 30% 70% / 70% 70% 30% 30%',
      animation: 'hanaBlobC 38s infinite ease-in-out',
    },
  ];

  return (
    <div
      aria-hidden="true"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: -1,
        overflow: 'hidden',
        background: 'var(--bg-body, #fbfaf8)',
        pointerEvents: 'none',
      }}
    >
      {blobs.map((style, i) => (
        <div key={i} style={{ position: 'absolute', filter: 'blur(70px)', ...style }} />
      ))}

      <style>{`
        @keyframes hanaBlobA {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33%      { transform: translate(18%, -14%) scale(1.08); }
          66%      { transform: translate(-12%, 12%) scale(0.94); }
        }

        @keyframes hanaBlobB {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33%      { transform: translate(-16%, 16%) scale(1.1); }
          66%      { transform: translate(14%, -10%) scale(0.9); }
        }

        @keyframes hanaBlobC {
          0%, 100% { transform: translate(-50%, -50%) scale(1); }
          50%      { transform: translate(-46%, -54%) scale(1.09); }
        }

        @media (prefers-reduced-motion: reduce) {
          [aria-hidden="true"] > div { animation: none !important; }
        }
      `}</style>
    </div>
  );
};

export default GradientMeshBackground;
